import Repository from "./repository"

export default {
    get() {
        return Repository.get("/api/s207-pay-method-changes/view")
    },
    post(params) {
        return Repository.post("/api/s207-pay-method-changes/add", params)
    }
}